"use client";

import { getSlateColorToken } from "@faire/retailer-shared/SlateMappings/getSlateColorToken";
import { useSettingProductTileIterationInTreatment } from "@faire/retailer-visitor-shared/settings/useSettingProductTileIteration";
import { getSlateIcon } from "@faire/web/slate/SlateMappings/getSlateIcon";
import { IFaireIcon } from "@faire/web-api--source/indigofair/data/IFaireIcon";
import React from "react";

export const BrandIcon = ({ brandIcon }: { brandIcon?: IFaireIcon }) => {
  const showTileIterationChanges = useSettingProductTileIterationInTreatment();
  if (!brandIcon) {
    return null;
  }
  const BrandIcon = getSlateIcon(brandIcon);
  return (
    <div className={showTileIterationChanges ? "pr-[4px]" : ""}>
      <BrandIcon
        data-test-id="brand-icon"
        fontSize="12px"
        color={getSlateColorToken(brandIcon.color_token)}
        titleAccess=""
      />
    </div>
  );
};
